import { Permission } from '@frontend/authorization';
import { EntityType, Rights } from '@frontend/common';
import { Application, Feature } from '@frontend/functionality/types';
import { Transaction, TransactionStateName } from '@frontend/transaction/types';

export const canContinueWithExistingDraftTransaction = (transaction: Transaction, currentUserId: string | null | undefined): boolean => {
    return transaction.state === TransactionStateName.TRANSACTION_DRAFT && !!currentUserId && transaction.user_id === currentUserId;
};

export const canDeleteExistingDraftTransaction = (transaction: Transaction, currentUserId: string | null | undefined): boolean => {
    return canContinueWithExistingDraftTransaction(transaction, currentUserId);
};

export const getTransactionDeletePermissions = (transaction: Transaction): Permission[] => [
    { item: EntityType.TRANSACTION, source: EntityType.ACCOUNT, right: Rights.DELETE, uid: transaction.account_id },
    { item: EntityType.TRANSACTION, source: EntityType.TRANSACTION, right: Rights.DELETE, uid: transaction.id }
];

const getTransactionListPath = (application: Application | null): string => {
    switch (application) {
        case Application.NIVALIZ:
            return '/nivaliz/transactions';
        case Application.LENDING:
            return '/lending/transactions';
        case Application.VENDING:
            return '/vending/transactions';
        case Application.LAUNDRY:
            return '/laundry/shipments';
        case Application.PUDO:
        default:
            return '/pudo/transactions';
    }
};

export const getTransactionDetailUrl = (transaction: Transaction): string => {
    const application = transaction.application ?? Application.PUDO;
    const detailKey = `${application}_${Feature.TRANSACTIONS}_${EntityType.TRANSACTION}_id-${transaction.id}`;
    const searchParams = new URLSearchParams({
        details: JSON.stringify([detailKey])
    });

    return `${getTransactionListPath(application)}?${searchParams.toString()}`;
};
